// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-kb-content {
  display: grid;
  grid-template-areas: "modal-kb-header" "modal-kb-body" "modal-kb-footer";
  background-color: white;
  position: relative;
  margin: 2% auto;
  border-radius: 4px;
  padding: 32px;
  font-family: "Open Sans", sans-serif;
}

.modal-title {
  font-size: 15px;
  font-weight: 700;
}

.override-modal-title {
  font-size: 20px;
  font-weight: 400;
}

.modal-kb-header {
  grid-area: modal-kb-header;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
}

.modal-kb-body {
  grid-area: modal-kb-body;
}

.override_modal_content {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}

.modal-kb-body span {
  font-size: 12px;
}

.modal-kb-footer {
  grid-area: modal-kb-footer;
  display: flex;
  column-gap: 10px;
  flex-direction: row-reverse;
  align-items: end;
  margin-top: 2rem;
}

.close_icon {
  cursor: pointer;
  background-color: transparent;
  height: 25px;
  border: none;
  padding: 0px;
}

.cancel_btn {
  font-family: "Open Sans", sans-serif;
  height: 36px;
  width: 76px;
  background-color: transparent;
  border: 1px solid var(--primary-main);
  color: var(--primary-main);
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
  transition: color 0.3s;
  &:hover {
    background-color: var(--primary-main);
    color: rgb(255, 255, 255);
  }
  &:disabled{
    background-color: #d0d0ce;
    color: #63666a;
    cursor: not-allowed;
    border: none;
  }
}
.rounded-button {
  border-radius: 50% !important;
}


.save_btn {
  font-family: "Open Sans", sans-serif;
  height: 36px;
  width: auto;
  min-width: 76px;
  background-color: var(--primary-main);
  border: none;
  color: white;
  font-weight: 400;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
}

.save_btn:disabled {
  background-color: #d0d0ce;
  color: #63666a;
  cursor: not-allowed;
}

.upload_btn_modal_override {
  height: 50%;
  width: 40%;
  border-radius: 4px;
  border: none;
  background-color: var(--primary-main);
  color: white;
  font-weight: 700;
  cursor: grab;
}

.dropzone_info_override {
  height: 20%;
  width: 20rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dropzone_info_override hr {
  height: 60%;
  width: 1px;
  border: none;
  color: #a7a8aa;
  background-color: #a7a8aa;
}

.dropzone_info_override h2 {
  margin-left: 1rem;
  font-weight: 700;
  font-size: 14px;
}

.fileName_stepTwo {
  display: flex;
  flex-direction: row;
}

.fileList_container_override {
  height: 20%;
  margin-top: 1rem;
  grid-area: selectedFiles;
}

.idleTime_modal_container {
  width: 40vw;
  height: 25vh;
  background-color: white;
  --input-hover-border-color: none;
  margin: 20% auto;
  padding: 1rem 2rem;
  outline: none;
  border-radius: 4px;
}

.idleTime_modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.idleTime_modal_footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
}

.idleTime_modal_header h2 {
  font-weight: 400;
  font-size: 1.3em;
  margin-bottom: 0.5rem;
}

.idleTime_modal_container p {
  font-size: 0.9rem;
}

.idleTime_button {
  height: 2rem;
  width: 4rem;
  border: none;
  background-color: var(--primary-main);
  color: white;
  border-radius: 2px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/css/modals.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,wEAAwE;EACxE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,sBAAsB;EACtB;IACE,qCAAqC;IACrC,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,YAAY;EACd;AACF;AACA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".modal-kb-content {\n  display: grid;\n  grid-template-areas: \"modal-kb-header\" \"modal-kb-body\" \"modal-kb-footer\";\n  background-color: white;\n  position: relative;\n  margin: 2% auto;\n  border-radius: 4px;\n  padding: 32px;\n  font-family: \"Open Sans\", sans-serif;\n}\n\n.modal-title {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.override-modal-title {\n  font-size: 20px;\n  font-weight: 400;\n}\n\n.modal-kb-header {\n  grid-area: modal-kb-header;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row-reverse;\n}\n\n.modal-kb-body {\n  grid-area: modal-kb-body;\n}\n\n.override_modal_content {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n}\n\n.modal-kb-body span {\n  font-size: 12px;\n}\n\n.modal-kb-footer {\n  grid-area: modal-kb-footer;\n  display: flex;\n  column-gap: 10px;\n  flex-direction: row-reverse;\n  align-items: end;\n  margin-top: 2rem;\n}\n\n.close_icon {\n  cursor: pointer;\n  background-color: transparent;\n  height: 25px;\n  border: none;\n  padding: 0px;\n}\n\n.cancel_btn {\n  font-family: \"Open Sans\", sans-serif;\n  height: 36px;\n  width: 76px;\n  background-color: transparent;\n  border: 1px solid var(--primary-main);\n  color: var(--primary-main);\n  border-radius: 5px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  transition: color 0.3s;\n  &:hover {\n    background-color: var(--primary-main);\n    color: rgb(255, 255, 255);\n  }\n  &:disabled{\n    background-color: #d0d0ce;\n    color: #63666a;\n    cursor: not-allowed;\n    border: none;\n  }\n}\n.rounded-button {\n  border-radius: 50% !important;\n}\n\n\n.save_btn {\n  font-family: \"Open Sans\", sans-serif;\n  height: 36px;\n  width: auto;\n  min-width: 76px;\n  background-color: var(--primary-main);\n  border: none;\n  color: white;\n  font-weight: 400;\n  border-radius: 5px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.save_btn:disabled {\n  background-color: #d0d0ce;\n  color: #63666a;\n  cursor: not-allowed;\n}\n\n.upload_btn_modal_override {\n  height: 50%;\n  width: 40%;\n  border-radius: 4px;\n  border: none;\n  background-color: var(--primary-main);\n  color: white;\n  font-weight: 700;\n  cursor: grab;\n}\n\n.dropzone_info_override {\n  height: 20%;\n  width: 20rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.dropzone_info_override hr {\n  height: 60%;\n  width: 1px;\n  border: none;\n  color: #a7a8aa;\n  background-color: #a7a8aa;\n}\n\n.dropzone_info_override h2 {\n  margin-left: 1rem;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.fileName_stepTwo {\n  display: flex;\n  flex-direction: row;\n}\n\n.fileList_container_override {\n  height: 20%;\n  margin-top: 1rem;\n  grid-area: selectedFiles;\n}\n\n.idleTime_modal_container {\n  width: 40vw;\n  height: 25vh;\n  background-color: white;\n  --input-hover-border-color: none;\n  margin: 20% auto;\n  padding: 1rem 2rem;\n  outline: none;\n  border-radius: 4px;\n}\n\n.idleTime_modal_header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.idleTime_modal_footer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n\n.idleTime_modal_header h2 {\n  font-weight: 400;\n  font-size: 1.3em;\n  margin-bottom: 0.5rem;\n}\n\n.idleTime_modal_container p {\n  font-size: 0.9rem;\n}\n\n.idleTime_button {\n  height: 2rem;\n  width: 4rem;\n  border: none;\n  background-color: var(--primary-main);\n  color: white;\n  border-radius: 2px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
